import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutComponent } from './components/aboutComponent/about.component';
import { CarInfoComponent } from './components/car_infoComponent/car_info.component';
import { CarListComponent } from './components/car_listComponent/car_list.Component';
import { ChangePassComponent } from './components/changePassComponent/changePass.component';
import { ComponyComponent } from './components/companyComponent/company.component';
import { IncomeComponent } from './components/IncomeComponent/Income.component';
import { LocationComponent } from './components/locationComponent/location.component';
import { LoginComponent } from './components/loginComponent/login.component';
import { RegisterComponent } from './components/registerComponent/register.component';
import { RepairsComponent } from './components/repairsComponent/repairs.component';
import { MapComponent } from './components/mapComponent/map.component';
import { UserComponent } from './components/userComponent/user.component';
import { ServicesComponent } from './components/servicesComponent/services.component';
import { SupportComponent } from './components/supportComponent/support.component';
import { EntryCarComponent } from './components/entryCar.Component/entryCar.component';
import { GurdGuard } from './gurd.guard';
import { ReportComponent } from './components/reportComponent/report.component';
import { StopMapComponent } from './components/stopMap.Component/stopMap.component';
import { DeviceComponent } from './components/deviceComponent/device.component';
import { DashbordComponent } from './components/dashbordComponent/dashbord.component';
import { TestComponent } from './components/testComponent/test.component';
import { SupportManagerComponent } from './components/supporManagerComponent/supportManager.component';
import { CarAreaComponent } from './components/car-areaComponent/car-area.component';
import { SaveUserComponent } from './components/saveUserComponent/saveUser.component';
import { RouteComponent } from './components/routeComponent/RouteComponent';
import { RefuleComponent } from './components/refuleComponent/refuleComponent';
import { ManageEventComponent } from './components/manageEventComponent/manageEventComponent';
import { BusLineComponent } from './components/busLineComponent/busLine.component';
import { ManageInputComponent } from './components/manageInputComponent/manageInputComponent';
import { MapInputComponent } from './components/mapInputComponent/mapInputComponent';
import { TrackerComponent } from './components/trackerComponent/tracker.component';
import { TrackerAllComponent } from './components/trackerAllComponent/trackerAll.component';
import { TaxiMeterComponent } from './components/taxiMeterComponent/taxiMeterComponent';
import { DashbordTaxiComponent } from './components/dashbordTaxiComponent/dashbordTaxi.component';
import { AdvertiseTaxiComponent } from './components/advertiseTaxiComponent/advertiseTaxiComponent';
import { DashbordAddsComponent } from './components/dashbordAddsComponent/dashbordAdds.component';
import { ReportAreaComponent } from './components/reportAreaComponent/reportAreaComponent';
import { ManageSosComponent } from './components/manageSosComponent/manageSosComponent';
import { DashboardproComponent } from './components/dashboardpro/dashboardpro.component';
import { DashboardCombinedComponent } from './components/dashboard-combined/dashboard-combined.component';
import { BaseInfoComponent } from './peysepar/base-info/base-info.component';
import { ServiceAreaComponent } from './peysepar/service-area/service-area.component';
import { OfficialTripsComponent } from './peysepar/official-trips/official-trips.component';
import { SaveSchoolComponent } from './schoolService/save-school/save-school.component';
import { NewStudentComponent } from './schoolService/new-student/new-student.component';
import { SearchStudentComponent } from './schoolService/search-student/search-student.component';
import { DriverServiceComponent } from './schoolService/driver-service/driver-service.component';
import { AbsenceStudentsComponent } from './schoolService/absence-students/absence-students.component';
import { AbsenceToSchoolComponent } from './schoolService/absence-to-school/absence-to-school.component';
import { AccumulativeDashboardComponent } from './schoolService/accumulative-dashboard/accumulative-dashboard.component';
import { BuffetComponent } from './schoolService/buffet/buffet.component';
import { ChangeAddressComponent } from './schoolService/change-address/change-address.component';
import { ConferencesComponent } from './schoolService/conferences/conferences.component';
import { DriverPerformanceComponent } from './schoolService/driver-performance/driver-performance.component';
import { FeedbackComponent } from './schoolService/feedback/feedback.component';
import { ManagerMessageComponent } from './schoolService/manager-message/manager-message.component';
import { RealTimeDashboardComponent } from './schoolService/real-time-dashboard/real-time-dashboard.component';
import { SearchDriversComponent } from './schoolService/search-drivers/search-drivers.component';
import { ServiceApplicant4schoolComponent } from './schoolService/service-applicant4school/service-applicant4school.component';
import { ServiceDeterminationComponent } from './schoolService/service-determination/service-determination.component';
import { SolutionComponent } from './schoolService/solution/solution.component';
import { StudentsAbsenceComponent } from './schoolService/students-absence/students-absence.component';
import { SuppoortComponent } from './schoolService/suppoort/suppoort.component';
import { DriverFunctionComponent } from './peysepar/driver-function/driver-function.component';
import { TripBaseChartComponent } from './peysepar/trip-base-chart/trip-base-chart.component';
import { OfficeDashboardComponent } from './peysepar/office-dashboard/office-dashboard.component';
import { PresellBuffetComponent } from './schoolService/presell-buffet/presell-buffet.component';
import { BuffetSalesReportComponent } from './schoolService/buffet-sales-report/buffet-sales-report.component';
import { SchoolDashboardComponent } from './schoolService/school-dashboard/school-dashboard.component';
import { FinancialReportComponent } from './schoolService/financial-report/financial-report.component';
import { TankerListComponent } from './Tanker/tanker-list/tanker-list.component';
import { SupplyLocationsComponent } from './Tanker/supply-locations/supply-locations.component';
import { TankerDashboardComponent } from './Tanker/tanker-dashboard/tanker-dashboard.component';
import { ServiceFeeComponent } from './schoolService/service-fee/service-fee.component';
import { RouteManagementComponent } from './components/route-management/route-management.component';
import { RouteScheduleComponent } from './components/route-schedule/route-schedule.component';
import { SafetyInspectionComponent } from './components/safety-inspection/safety-inspection.component';
import { ServicePartsComponent } from './components/service-parts/service-parts.component';
import { PeriodicVisitsComponent } from './components/periodic-visits/periodic-visits.component';
import { RouteDashboardComponent } from './components/route-dashboard/route-dashboard.component';
import { BusTicketQrcodeComponent } from './components/bus-ticket-qrcode/bus-ticket-qrcode.component';
import { InspectionSearchComponent } from './components/inspection-search/inspection-search.component';
import { PasswordSettingComponent } from './components/password-settings/password-setting/password-setting.component';
import { TempAccessLoginComponent } from './components/temp-access-login/temp-access-login.component';
import { TempAccessAdminComponent } from './components/temp-access-admin/temp-access-admin.component';
import { ViolationsComponent } from './components/violations/violations.component';
import { SearchTripsComponent } from './peysepar/search-trips/search-trips.component';
import { ServiceCostsComponent } from './components/service-costs/service-costs.component';
import { TripStatusComponent } from './components/trip-status/trip-status.component';
import { ChecksReportComponent } from './components/checks-report/checks-report.component';
import { BusyRoutesComponent } from './components/busy-routes/busy-routes.component';
import { UserChartComponent } from './components/user-chart/user-chart.component';
import { ChartAccessDetermineComponent } from './components/chart-access-determine/chart-access-determine.component';
import { NewTripUserComponent } from './components/new-trip-user/new-trip-user.component';
import { TripNewsComponent } from './components/trip-news/trip-news.component';
import { RolesRoleAccessesComponent } from './roles-role-accesses/roles-role-accesses.component';
import { ActiveRentComponent } from './components/active-rent/active-rent.component';
import { BaseInfoRentalComponent } from './components/base-info-rental/base-info-rental.component';
import { PerformanceDateRentComponent } from './components/performance-date-rent/performance-date-rent.component';
import { AddedCarsComponent } from './added-cars/added-cars.component';
import { TripDriversComponent } from './components/trip-drivers/trip-drivers.component';
import { DetailServiceComponent } from './components/detail-service/detail-service.component';
import { ScrapCarsComponent } from './components/scrap-cars/scrap-cars.component';
import { TaxiManageComponent } from './components/taxi-manage/taxi-manage.component';
import { TaxiCalendarComponent } from './components/taxi-calendar/taxi-calendar.component';
import { TaxilonTariffComponent } from './components/taxilon-tariff/taxilon-tariff.component';
import { TaxilonSupportComponent } from './components/taxilon-support/taxilon-support.component';
import { TaxilonSearchComponent } from './components/taxilon-search/taxilon-search.component';
import { TaxilonSearchPassengerComponent } from './components/taxilon-search-passenger/taxilon-search-passenger.component';
import { TaxilonDebitCreditComponent } from './components/taxilon-debit-credit/taxilon-debit-credit.component';
import { TaxilonManageAdsComponent } from './components/taxilon-manage-ads/taxilon-manage-ads.component';
import { PaymentComponent } from './components/payment/payment.component';
import { NewsComponent } from './components/news/news.component';
import { EducationComponent } from './components/education/education.component';
import { EmdadranSearchComponent } from './components/emdadran-search/emdadran-search.component';
import { ReportPaymentComponent } from './components/report-payment/report-payment.component';
import { TaxilonDashbordComponent } from './components/taxilon-dashbord/taxilon-dashbord.component';
import { EmdadranDashbordComponent } from './components/emdadran-dashbord/emdadran-dashbord.component';
import { AyabZahabComponent } from './components/ayab-zahab/ayab-zahab.component';
import { EmdadranBusinessComponent } from './components/emdadran-business/emdadran-business.component';
import { SmartClusteringComponent } from './schoolService/smart-clustering/smart-clustering.component';
import { AyabZahabDashboardComponent } from './components/ayab-zahab-dashboard/ayab-zahab-dashboard.component';
import { ManageDriverPerformanceComponent } from './manage-driver-performance/manage-driver-performance.component';
import { SchollContractorComponent } from './scholl-contractor/scholl-contractor.component';
import { NetConsumedComponent } from './components/net-consumed/net-consumed.component';
import { SchoolStudentReportDailyComponent } from './components/school-student-report-daily/school-student-report-daily.component';
import { MonitoringDashboardComponent } from './components/monitoring-dashboard/monitoring-dashboard.component';
import { SchoolRequestAllocationComponent } from './components/school-request-allocation/school-request-allocation.component';
import { SchoolParentRequestsComponent } from './components/school-parent-requests/school-parent-requests.component';
import { SchoolSearchRequestsComponent } from './components/school-search-requests/school-search-requests.component';
import { SchoolContractsComponent } from './components/school-contracts/school-contracts.component';
import { EcuInformationComponent } from './components/ecu-information/ecu-information.component';
import { CctvVideoLocationsComponent } from './components/cctv-video-locations/cctv-video-locations.component';
import { CustomSurveillanceComponent } from './components/custom-surveillance/custom-surveillance.component';
import { CctvCamerasComponent } from './components/cctv-cameras/cctv-cameras.component';
import { DotoneLiveComponent } from './components/dotone-live/dotone-live.component';
import { CctvFilmReportComponent } from './components/cctv-film-report/cctv-film-report.component';
import { CctvFilmStatusComponent } from './components/cctv-film-status/cctv-film-status.component';
import { ExtraClassesComponent } from './components/extra-classes/extra-classes.component';
import { EcuChartComponent } from './components/ecu-chart/ecu-chart.component';
import { EntryExitMadonikComponent } from './components/entry-exit-madonik/entry-exit-madonik.component';
import { FisheriesDashbordComponent } from './components/fisheries-dashbord/fisheries-dashbord.component';
import { VehicleRenewalComponent } from './components/vehicle-renewal/vehicle-renewal.component';
import { OfflineVehiclesComponent } from './components/offline-vehicles/offline-vehicles.component';
import { TransitRouteComponent } from './components/transit-route/transit-route.component';
import { TransitPerformanceComponent } from './components/transit-performance/transit-performance.component';
import { TransitTimeComponent } from './components/transit-performance/transit-time/transit-time.component';
import { TransitBarnamehComponent } from './components/transit-barnameh/transit-barnameh.component';
import { TransitReportStopComponent } from './components/transit-report-stop/transit-report-stop.component';
import { WithoutPlanningReportComponent } from './components/without-planning-report/without-planning-report.component';
import { ReportFlowmeterComponent } from './components/report-flowmeter/report-flowmeter.component';
import { VehicleDivisionComponent } from './components/vehicle-division/vehicle-division.component';
import { DivisionTotalComponent } from './components/division-total/division-total.component';
import { PreRegistrationComponent } from './components/pre-registration/pre-registration.component';
import { LocationTimelineComponent } from './components/location-timeline/location-timeline.component';
import { DriverInfoComponent } from './components/driver-info/driver-info.component';
import { AnalysisDischargesComponent } from './Tanker/analysis-discharges/analysis-discharges.component';
import { AnalyzeBubbleMapComponent } from './Tanker/analyze-bubble-map/analyze-bubble-map.component';
import { GpsInstallerComponent } from './components/gps-installer/gps-installer.component';
import { TaxiManageVecationComponent } from './components/taxi-manage-vecation/taxi-manage-vecation.component';
import { TaxiMonthlyReportComponent } from './components/taxi-monthly-report/taxi-monthly-report.component';
import { TaxiStatusDashboardComponent } from './components/taxi-status-dashboard/taxi-status-dashboard.component';
import { TaxiMonthlyReportDetailsComponent } from './components/taxi-monthly-report-details/taxi-monthly-report-details.component';
import { TaxiDashboardComponent } from './components/taxi-dashboard/taxi-dashboard.component';
import { PreRegistrationDashboardComponent } from './components/pre-registration-dashboard/pre-registration-dashboard.component';
import { OnlineUsersComponent } from './components/online-users/online-users.component';
import { TankerCustomerManagementComponent } from './Tanker/tanker-customer-management/tanker-customer-management.component';
import { TankerPreRegestrationComponent } from './components/tanker-pre-regestration/tanker-pre-regestration.component';
import { CanDashComponent } from './components/can-dash/can-dash.component';
import { VcuComponent } from './components/can-dash/pages/vcu/vcu.component';
import { CanDashFullInfoComponent } from './components/can-dash-full-info/can-dash-full-info.component';
import { OverviewComponent } from './components/can-dash-full-info/pages/overview/overview.component';
import { BmsComponent } from './components/can-dash-full-info/pages/bms/bms.component';
import { BcmComponent } from './components/can-dash-full-info/pages/bcm/bcm.component';
import { TmsComponent } from './components/can-dash-full-info/pages/tms/tms.component';
import { TpmsComponent } from './components/can-dash-full-info/pages/tpms/tpms.component';
import { FaultsComponent } from './components/can-dash-full-info/pages/faults/faults.component';
import { FuelBasedReportComponent } from './components/fuel-based-report/fuel-based-report.component';
import { CctvDashboardComponent } from './components/cctv-dashboard/cctv-dashboard.component';
import { TelemetryCanAnalyzerComponent } from './components/telemetry-can-analyzer/telemetry-can-analyzer.component';
import { FleetdiagUsersComponent } from './components/fleetdiag-users/fleetdiag-users.component';
import { FleetdiagDashboardComponent } from './components/fleetdiag-dashboard/fleetdiag-dashboard.component';
import { FleetdiagDashboardProComponent } from './components/fleetdiag-dashboard-pro/fleetdiag-dashboard-pro.component';
import { FleetdiagLiveParametersComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-live-parameters/fleetdiag-live-parameters.component';
import { FleetdiagAllItemsComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-all-items/fleetdiag-all-items.component';
import { FleetdiagFullscreenChartComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-fullscreen-chart/fleetdiag-fullscreen-chart.component';
import { FleetdiagHealthReportComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-health-report/fleetdiag-health-report.component';
import { FleetdiagDrivingQualityComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-driving-quality/fleetdiag-driving-quality.component';
import { FleetdiagObdMonitorComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-obd-monitor/fleetdiag-obd-monitor.component';
import { FleetdiagEcuStatusComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-ecu-status/fleetdiag-ecu-status.component';
import { TankerSupplyDetailsComponent } from './Tanker/tanker-supply-details/tanker-supply-details.component';
import { TankerShowAllMapComponent } from './Tanker/tanker-show-all-map/tanker-show-all-map.component';
import { TankerIllegalWaterPercentageComponent } from './Tanker/tanker-illegal-water-percentage/tanker-illegal-water-percentage.component';
import { TankerDriversRiskRankingComponent } from './Tanker/tanker-drivers-risk-ranking/tanker-drivers-risk-ranking.component';
import { TankerIllegalWaterSourcesComponent } from './Tanker/tanker-illegal-water-sources/tanker-illegal-water-sources.component';
import { DeviceRegistrationComponent } from './components/device-registration/device-registration.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: '', component: MapComponent, canActivate: [GurdGuard] },
  { path: 'about', component: AboutComponent, canActivate: [GurdGuard] },
  { path: 'company', component: ComponyComponent, canActivate: [GurdGuard] },
  { path: 'changePass', component: ChangePassComponent, canActivate: [GurdGuard] },
  { path: 'update-password', component: ChangePassComponent, canActivate: [GurdGuard] },
  { path: 'user', component: UserComponent, canActivate: [GurdGuard] },
  { path: 'carList', component: CarListComponent, canActivate: [GurdGuard] },
  { path: 'carInfo/:id', component: CarInfoComponent, canActivate: [GurdGuard] },
  { path: ':redirect/carInfo/:id', component: CarInfoComponent, canActivate: [GurdGuard] },
  { path: 'surveillance/:id', component: CustomSurveillanceComponent, canActivate: [GurdGuard] },
  { path: 'route/:id', component: RouteComponent, canActivate: [GurdGuard] }, // 1 
  { path: 'tanker-route/:id', component: RouteComponent, canActivate: [GurdGuard] }, // 2
  { path: 'route/:id/:polygon', component: RouteComponent, canActivate: [GurdGuard] }, // 3
  { path: 'location/:id', component: LocationComponent, canActivate: [GurdGuard] },
  { path: 'repairs/:id', component: RepairsComponent, canActivate: [GurdGuard] },
  { path: 'income/:id', component: IncomeComponent, canActivate: [GurdGuard] },
  { path: 'services/:id', component: ServicesComponent, canActivate: [GurdGuard] },
  { path: 'support/:id', component: SupportComponent, canActivate: [GurdGuard] },
  { path: 'transformation/:id', component: RefuleComponent, canActivate: [GurdGuard] }, // 1
  { path: 'ecu-chart/:id/:iobd', component: EcuChartComponent, canActivate: [GurdGuard] },
  { path: 'supportManager', component: SupportManagerComponent, canActivate: [GurdGuard] },
  { path: 'online-users', component: OnlineUsersComponent, canActivate: [GurdGuard] },
  { path: 'ServiceAreas', component: SaveSchoolComponent, canActivate: [GurdGuard] }, // 1
  { path: 'tracker/:id', component: TrackerComponent, canActivate: [GurdGuard] }, // 1
  { path: 'tempTracker/:id', component: TrackerComponent, }, // 2
  { path: 'live', component: DotoneLiveComponent, }, // 2
  { path: 'carList-Tracker', component: TrackerComponent, }, // 3
  { path: 'entryCar/:id', component: EntryCarComponent, canActivate: [GurdGuard] }, // 1
  { path: 'report/:id', component: ReportComponent, canActivate: [GurdGuard] },
  { path: 'report/:id/:type', component: ReportComponent, canActivate: [GurdGuard] },
  { path: 'report/:id/:type/:polygan', component: ReportComponent, canActivate: [GurdGuard] },
  { path: 'entryCar/:id/:Imei', component: EntryCarComponent, canActivate: [GurdGuard] }, // 2
  { path: 'stopMap', component: StopMapComponent, canActivate: [GurdGuard] },
  { path: 'stopMap/:id', component: StopMapComponent, canActivate: [GurdGuard] },
  { path: 'stopMap/:id/:polygan', component: StopMapComponent, canActivate: [GurdGuard] },
  { path: 'device', component: DeviceComponent, canActivate: [GurdGuard] },
  { path: 'device/registration', component: DeviceRegistrationComponent, canActivate: [GurdGuard] },
  { path: 'dashbord', component: DashbordComponent, canActivate: [GurdGuard] }, // 1
  { path: 'detailedDashboard', component: DashboardproComponent, canActivate: [GurdGuard] },

  { path: 'fisheries-dashbord', component: FisheriesDashbordComponent, canActivate: [GurdGuard] },

  { path: 'hybridDashboard', component: DashboardCombinedComponent, canActivate: [GurdGuard] },

  { path: 'dashbord/:id', component: DashbordComponent, canActivate: [GurdGuard] }, // 2

  { path: 'dashbordTaxi', component: DashbordTaxiComponent, canActivate: [GurdGuard] },

  { path: 'dashbordTaxi/:id', component: DashbordTaxiComponent, canActivate: [GurdGuard] },

  { path: 'carArea/:id', component: CarAreaComponent, canActivate: [GurdGuard] },

  { path: 'test', component: TestComponent, canActivate: [GurdGuard] },

  { path: 'saveUser', component: SaveUserComponent, canActivate: [GurdGuard] }, // 1

  { path: 'saveUser/:iSystemUser', component: SaveUserComponent, canActivate: [GurdGuard] }, // 2

  { path: 'refule/:id', component: RefuleComponent, canActivate: [GurdGuard] }, // 2

  { path: 'manageEvent', component: ManageEventComponent, canActivate: [GurdGuard] }, // 1

  { path: 'daily-event', component: ManageEventComponent, canActivate: [GurdGuard] }, // 2

  { path: 'manageInput', component: ManageInputComponent, canActivate: [GurdGuard] },

  { path: 'mapInput', component: MapInputComponent, canActivate: [GurdGuard] }, // 1

  { path: 'mapInput/report', component: MapInputComponent, canActivate: [GurdGuard] }, // 2

  { path: 'busLine', component: BusLineComponent, canActivate: [GurdGuard] },

  { path: 'taxi-line', component: BusLineComponent, canActivate: [GurdGuard] },

  { path: 'trackerAll', component: TrackerAllComponent },

  { path: 'taxiMeter', component: TaxiMeterComponent, canActivate: [GurdGuard] },

  { path: 'advertiseTaxi', component: AdvertiseTaxiComponent, canActivate: [GurdGuard] },

  { path: 'dashbordAdds', component: DashbordAddsComponent, canActivate: [GurdGuard] },

  { path: 'reportArea', component: ReportAreaComponent, canActivate: [GurdGuard] },

  { path: 'manageSos', component: ManageSosComponent, canActivate: [GurdGuard] },

  { path: 'vehicle-renewal', component: VehicleRenewalComponent, canActivate: [GurdGuard] },

  { path: 'vehicles-offline', component: OfflineVehiclesComponent, canActivate: [GurdGuard] },

  { path: 'location-timeline', redirectTo: 'vehicle-management/location-timeline', pathMatch: 'full' },

  {
    path: 'tripAutomation', canActivate: [GurdGuard], children: [

      { path: '', component: BaseInfoComponent },

      { path: 'serviceArea', component: ServiceAreaComponent },

      { path: 'officials', component: OfficialTripsComponent }

    ]

  },

  // مدیریت وسایل نقلیه

  {
    path: 'vehicle-management', canActivate: [GurdGuard], children: [

      { path: 'added-cars', component: AddedCarsComponent },

      { path: 'scrap-cars', component: ScrapCarsComponent },

      { path: 'division', component: VehicleDivisionComponent },

      { path: 'division/totoal', component: DivisionTotalComponent },

      { path: 'pre-registration/shilat', component: PreRegistrationComponent },

      { path: 'pre-registration/tanker', component: TankerPreRegestrationComponent },

      { path: 'pre-registration/dashboard', component: PreRegistrationDashboardComponent },

      { path: 'location-timeline', component: LocationTimelineComponent },

      { path: 'installer', component: GpsInstallerComponent },

      { path: 'taxi/manage-vacation', component: TaxiManageVecationComponent },

      { path: 'taxi/monthly-report', component: TaxiMonthlyReportComponent },

      { path: 'taxi/monthly-report/:id', component: TaxiMonthlyReportDetailsComponent },

      { path: 'taxi/status-dashboard', component: TaxiStatusDashboardComponent },

      { path: 'taxi/dashboard', component: TaxiDashboardComponent },

    ]

  },

  // ترانزیت

  {
    path: 'transit', canActivate: [GurdGuard], children: [

      { path: 'route-management', component: TransitRouteComponent },

      { path: 'barnameh', component: TransitBarnamehComponent },

      { path: 'performance-report', component: TransitPerformanceComponent },

      { path: 'without-planning-report', component: WithoutPlanningReportComponent },

      { path: 'route-stops/:id', component: TransitReportStopComponent },

      { path: 'time-report', component: TransitTimeComponent },

    ]

  },

  // اتوماسیون سفر

  {
    path: 'trip/automation', canActivate: [GurdGuard], children: [

      { path: 'office-travel', component: OfficialTripsComponent },

      { path: 'staff-travel', component: OfficialTripsComponent },

      { path: 'manage-travel', component: OfficialTripsComponent },

      { path: 'planning-travel', component: DriverServiceComponent }, // 1

    ]

  },

  // جستجو و داشبورد سفر

  {
    path: 'trip/dashboard', canActivate: [GurdGuard], children: [

      { path: 'office-travel', component: OfficeDashboardComponent }, // 1

      { path: 'driver-function', component: DriverFunctionComponent }, // 1

      { path: 'search-trips', component: SearchTripsComponent },

      { path: 'search-personnel', component: SearchStudentComponent }, // 2

      { path: 'trip-status', component: TripStatusComponent }, // 1

      { path: 'quality-chart-drivers', component: TripStatusComponent }, // 2

      { path: 'search-driver', component: TripDriversComponent },

      { path: 'search-driver/:strUnitID', component: TripDriversComponent },

    ]

  },

  // گزارش عملکردی سفر

  {
    path: 'trip/report', canActivate: [GurdGuard], children: [

      { path: 'drivers-function', component: DriverFunctionComponent }, // 2

      { path: 'drivers-total-function', component: DriverFunctionComponent }, // 3

      { path: 'planning-trip', component: DriverServiceComponent }, // 2

      { path: 'presence-absence-drivers', component: DriverFunctionComponent }, // 4

    ]

  },

  // مدیریت کاربران سفر

  {
    path: 'trip/manage-users', canActivate: [GurdGuard], children: [

      { path: 'personnel', component: NewStudentComponent }, // 1

      { path: 'chart-definition', component: UserChartComponent },

      { path: 'chart-access-determine', component: ChartAccessDetermineComponent },

      { path: 'new-user', component: NewTripUserComponent },

    ]

  },

  // اطلاعات پایه سفر

  {
    path: 'basic-information', canActivate: [GurdGuard], children: [

      { path: 'service-costs', component: ServiceCostsComponent },

      { path: 'busy-routes', component: BusyRoutesComponent },

      { path: 'news', component: TripNewsComponent },

    ]

  },

  // اطلاعات CAN خودرو
  {
    path: 'can',
    canActivate: [GurdGuard],
    children: [
      {
        path: ':id',
        children: [
          {
            path: 'basic-info',
            component: CanDashComponent,
            children: [
              { path: 'overview', component: VcuComponent, data: { parentSection: 'basic-info' } },
              { path: 'data', component: EcuInformationComponent, data: { parentSection: 'basic-info' } },
              { path: 'data-chart/:iobd', component: EcuChartComponent, data: { parentSection: 'basic-info' } },
              { path: '', redirectTo: 'overview', pathMatch: 'full' },
              { path: '**', redirectTo: 'overview' },
            ]
          },
          {
            path: 'full-info',
            component: CanDashFullInfoComponent,
            children: [
              { path: 'overview', component: BcmComponent },
              { path: 'bms', component: BmsComponent },
              { path: 'vcu', component: VcuComponent, data: { parentSection: 'full-info' } },
              { path: 'bcm', component: OverviewComponent },
              { path: 'tms', component: TmsComponent },
              { path: 'data', component: EcuInformationComponent, data: { parentSection: 'full-info' } },
              { path: 'data-chart/:iobd', component: EcuChartComponent, data: { parentSection: 'full-info' } },
              { path: 'tpms', component: TpmsComponent },
              { path: 'faults', component: FaultsComponent },
              { path: '', redirectTo: 'overview', pathMatch: 'full' },
              { path: '**', redirectTo: 'overview' },
            ]
          }
        ]
      }
    ]
  },

  // مدونیک

  {
    path: 'school', canActivate: [GurdGuard], children: [

      { path: 'newSchool', component: SaveSchoolComponent }, // 2

      { path: 'userSchool', component: SaveUserComponent }, // 3

      { path: 'newStudent', component: NewStudentComponent }, // 2

      { path: 'extra-classes', component: ExtraClassesComponent },

      { path: 'searchStudent', component: SearchStudentComponent }, // 1

      { path: 'driverService', component: DriverServiceComponent }, // 3

      { path: 'driverPerformance', component: DriverPerformanceComponent },

      { path: 'realTime-Dashboard', component: RealTimeDashboardComponent },

      { path: 'accumulative-Dashboard', component: AccumulativeDashboardComponent },

      { path: 'searchDrivers', component: SearchDriversComponent },

      { path: 'service-Absence', component: StudentsAbsenceComponent },

      { path: 'change-Address', component: ChangeAddressComponent },

      { path: 'complaints', component: FeedbackComponent },

      { path: 'service-Determination', component: ServiceDeterminationComponent },

      { path: 'smart-clustering', component: SmartClusteringComponent },

      { path: 'absenceTo-School', component: AbsenceToSchoolComponent },

      { path: 'absence-Students', component: AbsenceStudentsComponent }, // 1

      { path: 'AttendingExams', component: AbsenceStudentsComponent }, // 2

      { path: 'present-Students', component: AbsenceStudentsComponent }, // 3

      { path: 'serviceApplicant-4school', component: ServiceApplicant4schoolComponent },

      { path: 'conferences', component: ConferencesComponent },

      { path: 'manager-Message', component: ManagerMessageComponent },

      { path: 'buffet', component: BuffetComponent },

      { path: 'solutions', component: SolutionComponent },

      { path: 'school-Support', component: SuppoortComponent },

      { path: 'presell-Buffet', component: PresellBuffetComponent },

      { path: 'buffetSales-Report', component: BuffetSalesReportComponent },

      { path: 'school-Dashboard', component: SchoolDashboardComponent },

      { path: 'monitoring-dashboard', component: MonitoringDashboardComponent },

      { path: 'financial-Report', component: FinancialReportComponent },

      { path: 'checks-Report', component: ChecksReportComponent },

      { path: 'service-fee', component: ServiceFeeComponent },

      { path: 'contractor', component: SchollContractorComponent },

      { path: 'contracts', component: SchoolContractsComponent },

      { path: 'daily-report', component: SchoolStudentReportDailyComponent },

      { path: 'request-allocation', component: SchoolRequestAllocationComponent },

      { path: 'parent-requests', component: SchoolParentRequestsComponent },

      { path: 'search-requests', component: SchoolSearchRequestsComponent },

      { path: 'entry-exit', component: EntryExitMadonikComponent },

    ]

  },

  // گزارشات

  {
    path: 'reportage', canActivate: [GurdGuard], children: [
      { path: 'TripBaseChart', component: TripBaseChartComponent },
      { path: 'officeTravel-Dashboard', component: OfficeDashboardComponent }, // 2
      { path: 'financial-reports', component: ManageDriverPerformanceComponent },
      { path: 'fuel-consumption', component: NetConsumedComponent },
      { path: 'flowmeter', component: ReportFlowmeterComponent },
      { path: 'fuel-based-report', component: FuelBasedReportComponent },

    ]
  },

  // تانکر 

  {
    path: 'tanker', canActivate: [GurdGuard], children: [
      { path: 'list', component: TankerListComponent },
      { path: 'Report', component: TankerListComponent },
      { path: 'base-Source', component: TankerListComponent },
      { path: 'base-Tanker', component: TankerListComponent },
      { path: 'show-all-in-map', component: TankerShowAllMapComponent },
      { path: 'supply-details/:id', component: TankerSupplyDetailsComponent },
      { path: 'Supply-locations', component: SupplyLocationsComponent },
      { path: 'dashbord', component: TankerDashboardComponent },
      { path: 'analysis-discharges', component: AnalysisDischargesComponent },
      { path: 'analysis-discharges/map', component: AnalyzeBubbleMapComponent },
      { path: 'customer-management', component: TankerCustomerManagementComponent },
      { path: 'illegal-water-percentage', component: TankerIllegalWaterPercentageComponent  },
      { path: 'drivers-risk-ranking', component: TankerDriversRiskRankingComponent },
      { path: 'illegal-water-sources', component: TankerIllegalWaterSourcesComponent },
    ]

  },

  // اجاره وسیله نقلیه

  {

    path: 'vehicle-rental', canActivate: [GurdGuard], children: [
      { path: 'active', component: ActiveRentComponent },
      { path: 'base-information', component: BaseInfoRentalComponent },
      { path: 'performance-byDate', component: PerformanceDateRentComponent },
      { path: 'rental-details', component: PerformanceDateRentComponent },
      { path: 'rent-dashboard', component: DashbordComponent },// 3
    ]

  },

  // تنظیمات

  {
    path: 'settings', children: [

      { path: 'security-options', component: PasswordSettingComponent },

    ]

  },

  // تاکسی لون

  {
    path: 'taxiLon', canActivate: [GurdGuard], children: [

      { path: 'manage-requests', component: TaxiManageComponent },

      { path: 'manage-requests-city', component: TaxiManageComponent },

      { path: 'driver-calendar', component: TaxiCalendarComponent },

      { path: 'tariff', component: TaxilonTariffComponent },

      { path: 'tariff-2', component: TaxilonTariffComponent },

      { path: 'manage-drivers', component: CarListComponent },

      { path: 'support', component: TaxilonSupportComponent },

      { path: 'search-trip', component: TaxilonSearchComponent },

      { path: 'search-passenger', component: TaxilonSearchPassengerComponent },

      { path: 'debit-credit', component: TaxilonDebitCreditComponent },

      { path: 'manage-ads', component: TaxilonManageAdsComponent },

      { path: 'report-payment', component: ReportPaymentComponent },

      { path: 'dashbord-reports', component: TaxilonDashbordComponent },



    ]

  },

  // امدادران

  {
    path: 'emdadran', canActivate: [GurdGuard], children: [
      { path: 'manage-requests', component: TaxiManageComponent },
      { path: 'search-requests', component: EmdadranSearchComponent },
      { path: 'search-requests/map', component: EmdadranSearchComponent },
      { path: 'report-payment', component: ReportPaymentComponent },
      { path: 'debit-credit', component: TaxilonDebitCreditComponent },
      { path: 'dashbord-reports', component: EmdadranDashbordComponent },
      { path: 'manage-business', component: EmdadranBusinessComponent },
    ]

  },

  // پرداخت

  {
    path: 'payment', children: [

      { path: 'ZarinpalCallback', component: PaymentComponent },

      { path: 'ZarinpalCallback/mobile', component: PaymentComponent },

    ]

  },

  // گزارش های ایاب ذهاب

  {
    path: 'ayab-zahab', canActivate: [GurdGuard], children: [

      { path: ':id/:type', component: AyabZahabComponent },

      { path: 'dashboard', component: AyabZahabDashboardComponent },

    ]

  },

  // نظارت تصویری

  {
    path: 'cctv-monitoring', canActivate: [GurdGuard], children: [
      { path: 'cameras', component: CctvCamerasComponent },
      { path: 'video-locations', component: CctvVideoLocationsComponent },
      { path: 'film-report', component: CctvFilmReportComponent },
      { path: 'status', component: CctvFilmStatusComponent },
    ]
  },

  // تلمتری
  {
    path: 'telemetry',
    canActivate: [GurdGuard],
    children: [
      { path: 'charge-status', component: CctvDashboardComponent },
      { path: 'can-analyzer', component: TelemetryCanAnalyzerComponent },
    ]
  },

  // تلمتری
  {
    path: 'fleetdiag',
    canActivate: [GurdGuard],
    children: [
      { path: 'users', component: FleetdiagUsersComponent },
      { path: 'dashboard/:slug', component: FleetdiagDashboardComponent },
      {
        path: ':id',
        children: [
          {
            path: 'workspace',
            children: [
              { path: '', component: FleetdiagDashboardProComponent },
              {
                path: 'live-data',
                children: [
                  { path: '', component: FleetdiagLiveParametersComponent },
                  { path: ':slug', component: FleetdiagAllItemsComponent },
                ]
              },
              { path: 'chart/:slug/:title', component: FleetdiagFullscreenChartComponent },
              { path: 'health-report', component: FleetdiagHealthReportComponent },
              { path: 'driving-quality', component: FleetdiagDrivingQualityComponent },
              { path: 'obd-status', component: FleetdiagObdMonitorComponent },
              { path: 'ecu-status', component: FleetdiagEcuStatusComponent },
            ]
          }
        ]
      }
    ]
  },

  { path: 'route-management', component: RouteManagementComponent, canActivate: [GurdGuard] },

  { path: 'route-schedule', component: RouteScheduleComponent, canActivate: [GurdGuard] },

  { path: 'route-dashboard', component: RouteDashboardComponent, canActivate: [GurdGuard] },

  { path: 'inspection/:id', component: SafetyInspectionComponent, canActivate: [GurdGuard] },

  { path: 'service-parts', component: ServicePartsComponent, canActivate: [GurdGuard] }, // 1

  { path: 'service-part/:id', component: ServicePartsComponent, canActivate: [GurdGuard] }, // 2

  { path: 'periodic-visit/:id', component: PeriodicVisitsComponent, canActivate: [GurdGuard] },

  { path: 'inspection-search', component: InspectionSearchComponent, canActivate: [GurdGuard] }, // 1

  { path: 'periodic-visits', component: InspectionSearchComponent, canActivate: [GurdGuard] }, // 2

  { path: 'validation', component: InspectionSearchComponent, canActivate: [GurdGuard] }, // 3

  { path: 'tempAccess', component: TempAccessAdminComponent, canActivate: [GurdGuard] },

  { path: 'violations/:id', component: ViolationsComponent, canActivate: [GurdGuard] },

  { path: 'roles-roleAccesses', component: RolesRoleAccessesComponent, canActivate: [GurdGuard] },

  { path: 'personnel/detail-service', component: DetailServiceComponent },

  { path: 'personnel/detail-service/:id/:y/:m/:d', component: DetailServiceComponent },

  { path: 'news', component: NewsComponent },

  { path: 'news/:id', component: NewsComponent },

  { path: 'educations', component: EducationComponent },

  { path: 'education/:id', component: EducationComponent },

  { path: 'report-payment', component: ReportPaymentComponent },

  { path: 'driver-info', component: DriverInfoComponent },

  { path: 'tp', component: BusTicketQrcodeComponent },

  { path: 'ta', component: TempAccessLoginComponent },

];

@NgModule({

  imports: [RouterModule.forRoot(routes)],

  exports: [RouterModule]

})

export class AppRoutingModule { }
